module.exports = __webpack_public_path__ + "static/media/p_31_4.8c9652a0.png";